import { Group, Image, Paper, Text } from '@mantine/core';
import moment from 'moment';

import { Declarant, EORIGIN_DATE_FORMAT } from '@e-origin/shared';

import Logo from '@assets/images/logo192.png';
import { useRetrieveDeclarantLogo } from '@hooks/declarant/useRetrieveDeclarantLogo';

interface UTBHeaderProps {
  declarant: Declarant;
  t: (path: string, variables?: Record<string, any>) => string;
}

export const UTBHeader = ({ declarant, t }: UTBHeaderProps) => {
  const { data: declarantLogo } = useRetrieveDeclarantLogo(declarant?._id, declarant?.logo ? true : false);
  return (
    <Paper mb="xs" p="xs" className="utb-header">
      <Group justify="space-between" align="center">
        <Group>
          <Image w={60} src={declarantLogo ? declarantLogo : Logo} alt="" />
          <Text>{[declarant.name, declarant.identificationNumber].filter((val) => !!val).join(' - ')}</Text>
        </Group>
        <Text>{t('HEADER.DATE', { date: moment().format(EORIGIN_DATE_FORMAT), time: moment().format('HH:mm') })}</Text>
      </Group>
    </Paper>
  );
};
